import React from 'react';
import styled from 'styled-components';
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';

import TextInput, { stripeInputStyle } from 'components/TextInput/NewTextInput';

interface Props {
  error?: string;
  cardHolderName: string;
  onCardHolderNameChange: (cardHolderName: string) => void;
}

const PaymentDetails = ({ cardHolderName, onCardHolderNameChange }: Props) => {
  return (
    <PaymentDetailsContainer>
      <Header>Enter Payment Details</Header>

      <CardNumberContainer>
        Card number
        <CardNumberElement style={stripeInputStyle} />
      </CardNumberContainer>

      <CardExpirationContainer>
        Expiration
        <CardExpiryElement style={stripeInputStyle} />
      </CardExpirationContainer>

      <CardCVVContainer>
        CVC
        <CardCVCElement style={stripeInputStyle} />
      </CardCVVContainer>

      <CardHolderName
        label="Cardholder name"
        placeholder="Enter full name"
        value={cardHolderName}
        onChange={e => onCardHolderNameChange(e.target.value)}
      />
    </PaymentDetailsContainer>
  );
};

const PaymentDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 12px;
  grid-template-rows: auto;
  grid-template-areas:
    'header header'
    'card-number card-number'
    'expiration cvv'
    'cardholder-name cardholder-name';

  padding: 16px 8px 16px 8px;
  margin: 28px -8px 16px -8px;

  background-color: #f3e7da4c;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 16px 65px 16px 40px;
    margin: 0px -20px 16px -48px;

    grid-template-columns: 4fr 2fr 1fr;
    grid-template-areas:
      'header header header'
      'card-number expiration cvv'
      'cardholder-name cardholder-name cardholder-name';
  }
`;

const Header = styled.h2`
  grid-area: header;
  margin-bottom: 12px;

  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 20px;
  line-height: 27px;
`;

const BaseCardContainer = styled.label`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 14px;
  border-bottom: 1px solid;
`;

const CardNumberContainer = styled(BaseCardContainer)`
  grid-area: card-number;
`;

const CardExpirationContainer = styled(BaseCardContainer)`
  grid-area: expiration;
`;

const CardCVVContainer = styled(BaseCardContainer)`
  grid-area: cvv;
`;

const CardHolderName = styled(TextInput)`
  grid-area: cardholder-name;
  max-width: 100%;
`;

export default PaymentDetails;
